// extracted by mini-css-extract-plugin
module.exports = {"buttons":"EditForm_buttons__3LkJy","cancelButton":"EditForm_cancelButton__1g5-X","singleButton":"EditForm_singleButton__wZNVv"};